angular.module('b2bLoginApp.controllers').controller('ExternalReviewsController', ["$scope", "$uibModal", "TranslationService", "$http", function ($scope, $uibModal, TranslationService, $http) {

    $scope.openForm = function () {
        try {
            window.SelfServiceGATracker.sendButtonClickEvent('add_reviews_manual', $scope.company ? $scope.company.id : null);
        } catch (e) { /* tracker not loaded */ }

        var modal = $uibModal.open({
            templateUrl: '/account/company-profile-public/request-external-review-modal.html',
            backdrop: 'static',
            scope: $scope,
            controller: ["$scope", function($scope) {
                $scope.reviewsAmount = 0;
                $scope.reviews = [];
                $scope.sentForms = [];

                $scope.initModal = function () {
                    $scope.addReviewForm();
                };

                $scope.reviewMessage = TranslationService.trans('company-profile-public.external-reviews.personal.message.default', {
                    firstName: $scope.company.primaryContactFirstName,
                    lastName: $scope.company.primaryContactLastName,
                    breakLine: '\n',
                });

                $scope.canRemove = function (reviewIndex) {
                    return reviewIndex !== 0;
                };
                $scope.removeReview = function (reviewIndex) {
                    $scope.reviewsAmount--;
                    $scope.reviews.splice(reviewIndex, 1);
                };

                $scope.addReviewForm = function () {
                    $scope.addReview();
                };

                $scope.addReview = function () {
                    $scope.reviews.push({
                        index: $scope.reviewsAmount,
                        customerName:   '',
                        email:  '',
                        submitted: false
                    });
                    $scope.reviewsAmount++;
                };

                $scope.showForm = function (reviewIndex) {
                    return (reviewIndex < $scope.reviewsAmount);
                };

                $scope.save = function () {
                    $scope.markReviewsAsSubmitted();
                    $scope.formSubmitted = true;

                    if ($scope.isValidForm() && $scope.messageForm.$valid) {

                        var postData = {
                            'reviews': $scope.reviews,
                            'reviewMessage': $scope.reviewMessage
                        };

                        $http.post('external-review-request.json', postData)
                            .then(function successCallback(response) {
                                if (response.data.result === 'failed') {
                                    $scope.updateFormOnError(response.data.failedReviews);
                                } else {
                                    modal.close();
                                }

                            }, function errorCallback() {});
                    }
                };

                $scope.updateFormOnError = function (failedReviews) {
                    var reviews = $scope.reviews;
                    $scope.reviews = [];

                    $scope.reviewsAmount = 0;
                    failedReviews.forEach(function (failedReviewIndex) {
                        var failedReview = reviews.find(function(review) {
                            return (review.index == failedReviewIndex);
                        });
                        failedReview.index = $scope.reviewsAmount;
                        $scope.reviews.push(failedReview);
                        $scope.reviewsAmount++;
                    });
                    $scope.reviewsAmount = $scope.reviews.length;
                };

                $scope.markReviewsAsSubmitted = function () {
                    $scope.reviews.forEach(function (review) {
                        review.submitted = true;
                    });
                };

                $scope.isValidForm = function () {
                    var isValid = true;
                    Object.keys($scope.reviews).forEach(function (reviewKey) {
                        if (!$scope.form[reviewKey].$valid && reviewKey < $scope.reviewsAmount) {
                            isValid = false;
                        }
                    });

                    return isValid;
                };

                $scope.getField = function (formId, name) {
                    return $scope.form[formId][name];
                };

                $scope.isInvalid = function (name, formId) {
                    if (angular.isDefined($scope.reviews[formId]) && $scope.reviews[formId].submitted) {
                        var field = $scope.getField(formId, name);
                        if (typeof field === 'undefined') {
                            return false;
                        } else {
                            return field.$invalid;
                        }
                    }
                };

                $scope.getErrorForField = function (field, formId) {
                    if (typeof $scope.form[formId][field] !== 'undefined' &&
                        typeof $scope.form[formId][field].$error !== 'undefined') {
                        return $scope.form[formId][field].$error;
                    }
                    return null;
                };

                $scope.initModal();
            }]
        });
    }
}]);
